import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
// import { routerMiddleware } from 'connected-react-router/immutable';
import { fromJS, Map } from 'immutable';
import history from 'client/utils/history';
import createRootReducer from './reducers';
import sagas from './sagas';

const sagaMiddleware = createSagaMiddleware();
const persistedState = localStorage.getItem('reduxState');
let middlewares = [thunk.withExtraArgument(), sagaMiddleware];

if (process.env.NODE_ENV === 'development') {
  middlewares = [...middlewares, logger];
}

const store = createStore(
  createRootReducer(history),
  persistedState ? fromJS(JSON.parse(persistedState)) : Map({}),
  applyMiddleware(...middlewares),
);

sagaMiddleware.run(sagas);

store.subscribe(() => {
  const reduxState = store.getState();
  localStorage.setItem('reduxState', JSON.stringify({
    Login: { authenticationData: reduxState.getIn(['Login', 'authenticationData']) },
    Profile: { profileData: reduxState.getIn(['Profile', 'profileData']) },
  }));
});

export default store;
